import * as React from 'react';
import { connect } from 'react-redux';
import { RouterProps, withRouter } from 'react-router-dom';
import { Dispatch } from 'redux';

import { changeToMultiTab } from '../../actions/EditorActions/EditorActions';
import { toggleSimulationFilterMobileThunk } from '../../actions/Simulation/SimulationFiltersActions';
import { EditorTopBarLeft } from '../../components/Editor/EditorTopBar/EditorTopBarLeft';
import { StateType } from '../../reducers';
import { getHasUpdatedPropertiesSelector } from '../../reducers/AlphaPropertiesReducer/AlphaPropertiesSelector';
import { hasMultiSimulationPermission } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import {
  activeTabIndexSelector,
  currentChildActiveTabLessOne,
  delaySelector,
  isSuperALphaSelector,
  regionSelector,
  universeSelector,
} from '../../reducers/EditorReducer/EditorSelector';
import {
  filtersCodeSelector,
  filtersLearnSelector,
  filtersResultsSelector,
  filtersSuperCodeSelector,
} from '../../reducers/SimulationReducer/FiltersReducer/FiltersSelector';
import { fetchingPercentageSelector, fetchingPostSelector } from '../../reducers/SimulationReducer/ProgressReducer/ProgressSelector';
import { DispatchConnect } from '../../types/';

interface EditorCodeBarStateProps {
  currentActiveTab: number;
  currentRegion?: string;
  currentDelay?: string;
  currentUniverse?: string;
  isMultiSimulation: boolean;
  isChild: boolean;
  fetchingPercentage: boolean;
  fetchingPost: boolean;
  hasUpdatedProperties: boolean;
  isSuperAlpha: boolean;
  filters: {
    superCode: boolean;
    code: boolean;
    results: boolean;
    learn: boolean;
  };
}
interface EditorCodeBarProps {
  showPropertiesTabModal: boolean;
  settingsOptions: any;
  handleShowPropertiesTabModalState: any;
}

interface EditorCodeBarStateDispatchers {
  dispatchChangeToMultiTab: (index: number) => void;
  dispatchToggleSimulationFilterMobile: (index: number, codeType: string, historyReplace: (path: string) => void) => void;
}

type EditorCodeBarGenericProps = EditorCodeBarStateProps & EditorCodeBarProps & EditorCodeBarStateDispatchers & RouterProps;
class EditorCodeBar extends React.Component<EditorCodeBarGenericProps> {
  handlerChangeToMultiSimulation = () => {
    if (this.props.fetchingPost || this.props.fetchingPercentage) {
      return;
    }

    if (this.props.hasUpdatedProperties === true && this.props.showPropertiesTabModal === false) {
      this.props.handleShowPropertiesTabModalState(() => this.handlerChangeToMultiSimulation());
    } else {
      this.props.dispatchChangeToMultiTab(this.props.currentActiveTab);
    }
  };

  handleToggleMobileCode = () => {
    const codeType = this.props.isSuperAlpha ? 'superCode' : 'code';
    if (!this.props.filters[codeType]) {
      this.props.dispatchToggleSimulationFilterMobile(this.props.currentActiveTab, codeType, this.props.history.replace);
    }
  };
  handleToggleMobileResults = () => {
    const codeType = this.props.isSuperAlpha ? 'superCode' : 'code';
    if (!this.props.filters.results) {
      this.props.dispatchToggleSimulationFilterMobile(this.props.currentActiveTab, codeType, this.props.history.replace);
    }
  };

  render() {
    const { currentDelay, currentRegion, currentUniverse, filters, isMultiSimulation, isChild, settingsOptions, isSuperAlpha } = this.props;

    return (
      <EditorTopBarLeft
        currentDelay={currentDelay}
        currentRegion={currentRegion}
        currentUniverse={currentUniverse}
        isMultiSimulation={isMultiSimulation}
        handlerChangeToMultiSimulation={this.handlerChangeToMultiSimulation}
        isChild={isChild}
        settingsOptions={settingsOptions}
        modifiers={this.props.fetchingPost || this.props.fetchingPercentage ? ['disabled'] : []}
        onClickCode={this.handleToggleMobileCode}
        onClickResults={this.handleToggleMobileResults}
        code={filters.superCode || filters.code}
        results={filters.results}
        isSuperAlpha={isSuperAlpha}
      />
    );
  }
}

export const mapStateToProps = (state: StateType): EditorCodeBarStateProps => ({
  // @ts-ignore
  currentActiveTab: activeTabIndexSelector(state),
  currentRegion: regionSelector(state),
  currentDelay: delaySelector(state),
  currentUniverse: universeSelector(state),
  isMultiSimulation: hasMultiSimulationPermission(state),
  isChild: currentChildActiveTabLessOne(state) > -1,
  // @ts-ignore
  fetchingPercentage: fetchingPercentageSelector(state),
  // @ts-ignore
  fetchingPost: fetchingPostSelector(state),
  // @ts-ignore
  hasUpdatedProperties: getHasUpdatedPropertiesSelector(state),
  isSuperAlpha: isSuperALphaSelector(state),
  filters: {
    code: filtersCodeSelector(state),
    superCode: filtersSuperCodeSelector(state),
    results: filtersResultsSelector(state),
    learn: filtersLearnSelector(state),
  },
});

export const mapDispatchToProps = (dispatch: Dispatch<any>): EditorCodeBarStateDispatchers => ({
  dispatchToggleSimulationFilterMobile: (tabIndex: number, codeType: string, historyReplace) => {
    dispatch(toggleSimulationFilterMobileThunk(tabIndex, codeType, historyReplace));
  },
  dispatchChangeToMultiTab: (index: number) => {
    dispatch(changeToMultiTab(index));
  },
});

export default withRouter(
  connect<EditorCodeBarStateProps, DispatchConnect<EditorCodeBarStateDispatchers>, any, StateType>(
    mapStateToProps,
    mapDispatchToProps
  )(EditorCodeBar)
);
